import { render } from "./WinterRider.vue?vue&type=template&id=77225b59"
import script from "./WinterRider.vue?vue&type=script&lang=js"
export * from "./WinterRider.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__